import React, { FC, useState } from "react";

// i18n
import messages from "./messages";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

// services
import { IPaymentMethodProvider } from "@modules/PaymentProcessing/services/paymentMethods";

import { IOutlets } from "@Libs/Transclusion/types/outlets";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { PaymentMethodForm } from "@modules/PaymentProcessing/Components/PaymentMethodForm/PaymentMethodForm";
import { ConfigureCreditCard as StripeConfigureCreditCard } from "./Adapters/Stripe/ConfigureCreditCard";

const PROVIDER_ADAPTERS = {
  stripe: StripeConfigureCreditCard,
  //adyen: AdyenCreditCardForm
};

type Props = Omit<
  IOutlets["configure-preferred-payment-method.body"]["props"],
  "paymentMethod" | "basket"
>;

export const ConfigureCreditCard: FC<Props> = ({ onSubmit, onBack }) => {
  const [isServerError, setIsServerError] = useState(false);

  const handleSubmit = async (
    provider: IPaymentMethodProvider<PaymentMethodType.CREDIT_CARD>
  ) => {
    await onSubmit?.<PaymentMethodType.CREDIT_CARD>(
      {
        provider,
        paymentMethod: PaymentMethodType.CREDIT_CARD,
      },
      {
        onError: async () => setIsServerError(true),
      }
    );
  };

  const Adapter = PROVIDER_ADAPTERS["stripe"];

  return (
    <PaymentMethodForm>
      {isServerError && <PaymentMethodForm.Error onClick={onBack} />}
      <PaymentMethodForm.Header
        onChangeClick={onBack}
        paymentMethod={PaymentMethodType.CREDIT_CARD}
      >
        <FormattedMessage {...messages.creditCard} />
      </PaymentMethodForm.Header>
      <PaymentMethodForm.Body>
        <Adapter onSubmit={handleSubmit} setIsServerError={setIsServerError} />
      </PaymentMethodForm.Body>
    </PaymentMethodForm>
  );
};
